<div class="table-container">
  <ul>
    <div>
      <button mat-button (click)="editDialog('')">
        <span class="material-icons">note_add</span> Adicionar Veículo
      </button>
    </div>
    <div class="table2">
      <table>
        <thead>
          <tr>
            <th>Modelo</th>
            <th>Transportadora</th>
            <th>Placa</th>
            <th>Chassis</th>
            <th>Vincode</th>
            <th>Ano Fabricação</th>
            <th>Perfil</th>
            <th>Combustível</th>
            <th>Capacidade Volumetrica</th>
            <th>Capacidade Peso</th>
            <th>Consumo</th>
            <th>Emissão</th>
            <th>Editar</th>
          </tr>
        </thead>
        <tbody *ngFor="let item of items">
          <tr [ngClass]="{ 'black-row': $even, 'grafiti-row': $odd }">
            <td>{{ item.modelo }}</td>
            <td>{{ item.transportadora }}</td>
            <td>{{ item.placa }}</td>
            <td>{{ item.chassis }}</td>
            <td>{{ item.vincode }}</td>
            <td>{{ item.fabricacao }}</td>
            <td>{{ item.perfil }}</td>
            <td>{{ item.combustivel }}</td>
            <td>{{ item.volume }}</td>
            <td>{{ item.peso }}</td>
            <td>{{ item.consumo }}</td>
            <td>{{ item.emissoes }}</td>
            <td>
              <i-feather name="edit" (click)="editDialog(item)"></i-feather>
              <span style="margin-left: 10px; margin-right: 10px;"></span>
              <i-feather name="delete" (click)="deleteItem(item.ID, urlConsulta, query)"
                class="button-spacing"></i-feather>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

  </ul>
</div>
<clr-modal [(clrModalOpen)]="dialogOpen" [clrModalSize]="'md'" class="dialog-container">
  <h2 class="modal-title">Adicionar Veículo</h2>
  <div class="modal-body">
    <form class="inputs">
      <div class="linha">
        <div class="conteudoForm">
          <label class="modal-label">Transportadora</label>
          <select id="transportadora" name="transportadora" [(ngModel)]="item.transportadora" class="modal-select1">
            <option *ngFor="let transportadora of carrier" [value]="transportadora.name">{{
              transportadora.name }}
            </option>
          </select>
        </div>
        <div  class="conteudoForm">
          <label class="modal-label">Modelo</label>
          <input type="string" name="modelo" [(ngModel)]="item.modelo" class="modal-input1">
        </div>
        <div  class="conteudoForm">
          <label class="modal-label">Ano Veículo</label>
          <input type="string" name="fabricacao" [(ngModel)]="item.fabricacao" class="modal-input1">
        </div>
      </div>
      <div class="linha">
        <div  class="conteudoForm">
          <label class="modal-label">Placa</label>
          <input type="string" name="placa" [(ngModel)]="item.placa" class="modal-input1">
        </div>
        <div  class="conteudoForm">
          <label class="modal-label">Chassis</label>
          <input type="string" name="chassis" [(ngModel)]="item.chassis" class="modal-input1">
        </div>
        <div  class="conteudoForm">
          <label class="modal-label">Vin Code</label>
          <input type="string" name="vincode" [(ngModel)]="item.vincode" class="modal-input1">
        </div>
      </div>
      <div class="linha">
        <div  class="conteudoForm">
          <label class="modal-label">Perfil</label>
          <select id="perfil" name="perfil" [(ngModel)]="item.perfil" class="modal-select1">
            <option *ngFor="let perfil of perfilVehicles" [value]="perfil">{{ perfil }}
            </option>
          </select>
        </div>
        <div  class="conteudoForm">
          <label class="modal-label">Volume</label>
          <input type="string" name="volume" [(ngModel)]="item.volume" class="modal-input1">
        </div>
        <div  class="conteudoForm">
          <label class="modal-label">Peso</label>
          <input type="string" name="peso" [(ngModel)]="item.peso" class="modal-input1">
        </div>
      </div>
      <div class="linha">
        <div  class="conteudoForm">
          <label class="modal-label">Combustivel</label>
          <select id="combustivel" name="combustivel" [(ngModel)]="item.combustivel" class="modal-select1">
            <option *ngFor="let combustivel of combustiveis" [value]="combustivel">{{ combustivel }}
            </option>
          </select>
        </div>
        <div  class="conteudoForm">
          <label class="modal-label">Consumo</label>
          <input type="string" name="consumo" [(ngModel)]="item.consumo" class="modal-input1">
        </div>
        <div  class="conteudoForm">
          <label class="modal-label">Emissões</label>
          <input type="string" name="emissoes" [(ngModel)]="item.emissoes" class="modal-input1">
        </div>
      </div>
      <div class="modal-div">
        <button class="modal-button" type="button" (click)="salvar()">Save</button>
        <button class="modal-button" type="button" (click)="cancel()">Cancel</button>
      </div>
    </form>
  </div>
</clr-modal>